import Logger from '../util/Logger';
import { popinApi, popinMultipartApi } from './api';

export const mediaApi = {
  uploadMedia: (media) => {
    console.log("Upload", media);
    return Promise.resolve().then(() => {
      if (!media) {
        Logger.info('reject uploadMedia()');
        throw Error('Must pass images');
      } else {
        const formData = new FormData();
        const blobProps = { type: media.type };
        if (media.type.startsWith('video')) {
          formData.append('video', new Blob([media], blobProps), media.name);
        } else {
          formData.append('photo', new Blob([media], blobProps), media.name);
        }
        return popinMultipartApi.post('/media/create', formData);
      }
    });
  },
  getMedia: (id) => {
    return Promise.resolve().then(() => {
      if (!id) {
        Logger.info('reject getMedia()');
        throw Error('Must pass media ID');
      }
      return popinApi.get(`/media/detail/${id}`);
    });
  }
};
